<app-tracked-time-list
  class="billed-tracked-time-list"
  [filter]="filter"
  [trackedTimes]="trackedTimes$ | async"
  [noTrackedTimeDescription]="noTrackedTimeDescription"
>
</app-tracked-time-list>
